export default class DragHorizontalDirective {
    constructor($document) {
        this.restrict = 'A';
        this.scope = {
            name: '@',
            hasPrevElement: '<',
            hasNextElement: '<'
        };
        this.$document = $document;
        this.drag = false;
        this.dragStartPositionX = 0;
        this.dragCurrentPositionX = 0;
        this.elm = null;
    }

    link(scope, elm) {

        this.$elm = elm;
        this.$scope = scope;

        let documentTouchMove = (event) => {
            this.dragCurrentPositionX = event.targetTouches[0].pageX;
            elm.css({transform: 'translateX(' + (this.dragCurrentPositionX - this.dragStartPositionX) + 'px)'});
        }

        let documentTouchUp = (event) => {
            this.stopDrag(event);
        };

        elm.on('touchstart', (event) => {
            this.dragCurrentPositionX = this.dragStartPositionX = event.targetTouches[0].pageX;
            this.$document.on('touchmove', documentTouchMove);
            this.$document.on('touchend', documentTouchUp);
            elm.addClass('dragging');
        });
    }

    stopDrag() {
        this.$elm.removeClass('dragging');

        const offset = this.dragCurrentPositionX - this.dragStartPositionX;
        let direction = '';

        if(Math.abs(offset) > 40 && offset < 0) {
            direction = 'next';
        } else if(Math.abs(offset) > 40 && offset > 0) {
            direction = 'prev';
        }

        if(direction === 'next' && this.$scope.hasNextElement) {
            this.$elm.css({transform: 'translateX(-100%)'});
        } else if(direction === 'prev' && this.$scope.hasPrevElement) {
            this.$elm.css({transform: 'translateX(100%)'});
        } else {
            this.$elm.css({transform: 'translateX(0)'});
        }

        this.$document.unbind('touchmove');
        this.$document.unbind('touchend');

        this.$scope.$emit('stopDrag', direction);
    }

    static directiveFactory($document) {
        'ngInject';

        return new DragHorizontalDirective($document);
    }
}
